/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const verifyMyPhoneBodyTwoCodeRegExp = new RegExp('^\\d{6}$');

export const VerifyMyPhoneBody = zod
  .object({
    csrfToken: zod.string(),
    expiresAt: zod.string(),
    flowId: zod.string().min(1),
    phoneNumber: zod.string(),
  })
  .describe(
    'Verification flow state to echo back on \/me\/phones\/verify. Absent when the OTP SMS could not be dispatched (the number was still added; use \/me\/phones\/resend).',
  )
  .and(
    zod.object({
      code: zod.string().regex(verifyMyPhoneBodyTwoCodeRegExp),
    }),
  );

export type VerifyMyPhoneBody = zod.input<typeof VerifyMyPhoneBody>;
export type VerifyMyPhoneBodyOutput = zod.output<typeof VerifyMyPhoneBody>;
